module.exports = require("core-js/library/fn/object/create");


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@babel_runtime-corejs2@7.9.2@@babel/runtime-corejs2/core-js/object/create.js
// module id = 2454
// module chunks = 0